export function ArrowSquareDown({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM12.045 8.3775L9.3975 11.025C9.285 11.1375 9.1425 11.19 9 11.19C8.8575 11.19 8.715 11.1375 8.6025 11.025L5.955 8.3775C5.7375 8.16 5.7375 7.8 5.955 7.5825C6.1725 7.365 6.5325 7.365 6.75 7.5825L9 9.8325L11.25 7.5825C11.4675 7.365 11.8275 7.365 12.045 7.5825C12.2625 7.8 12.2625 8.1525 12.045 8.3775Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
